import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { PlusWidgetTheme } from "scmp-app/components/plus/plus-widget";
import { PlusWidgetNewsAgenda } from "scmp-app/components/plus/plus-widget/plus-widget-news-agenda";
import { PlusWidgetLightThemeStyle } from "scmp-app/components/plus/plus-widget/styles";

export const LogoPlusContainer = styled.div`
  grid-area: logo-plus;

  margin-block-end: 16px;
  padding-block-end: 12px;
  border-block-end: 1px solid rgba(255, 255, 255, 0.3);
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16.41px;
  text-transform: uppercase;
`;

export const DailyPulse = styled.div`
  grid-area: daily-pulse;

  margin-block-end: 16px;
  padding-block-end: 16px;
  border-block-end: 1px solid rgba(255, 255, 255, 0.3);

  ${theme.breakpoints.between("tablet", "desktop")} {
    margin-block-end: 0;
    padding-block-end: 0;
    border-inline-end: 1px solid rgba(255, 255, 255, 0.3);
    border-block-end: 0;
  }
`;

export const NewsAgenda = styled.div`
  grid-area: news-agenda;

  margin-block-end: 16px;
  padding-block-end: 16px;
  border-block-end: 1px solid rgba(255, 255, 255, 0.3);

  ${theme.breakpoints.between("tablet", "desktop")} {
    margin-block-end: 0;
    padding-block: 20px 0;
    padding-inline-end: 24px;
    border-block-end: 0;
    border-inline-end: 1px solid rgba(255, 255, 255, 0.3);
  }
`;

export const StyledPlusWidgetNewsAgenda = styled(PlusWidgetNewsAgenda)`
  margin-block-start: 16px;
`;

export const HighlightsFromScmpPlus = styled.div`
  grid-area: highlights-from-scmp-plus;

  display: flex;
  flex-direction: column;
  gap: 16px;
`;

type ContainerProps = {
  $plusWidgetTheme: PlusWidgetTheme;
};

export const Container = styled.div<ContainerProps>`
  display: grid;
  grid:
    "logo-plus" min-content
    "daily-pulse" min-content
    "news-agenda" min-content
    "highlights-from-scmp-plus" min-content
    / 1fr;

  ${theme.breakpoints.between("tablet", "desktop")} {
    grid:
      "logo-plus logo-plus" min-content
      "daily-pulse highlights-from-scmp-plus" min-content
      "news-agenda highlights-from-scmp-plus" 1fr
      / 1fr 1fr;
    column-gap: 24px;
  }

  ${props =>
    props.$plusWidgetTheme === PlusWidgetTheme.LIGHT &&
    css`
      ${theme.breakpoints.between("tablet", "desktop")} {
        grid:
          "logo-plus" min-content
          "daily-pulse" min-content
          "news-agenda" min-content
          "highlights-from-scmp-plus" min-content / 1fr;
        gap: 0;
        ${NewsAgenda} {
          padding-block-start: 0;
          padding-inline: 0;
        }
      }
      ${DailyPulse}, ${NewsAgenda} {
        ${PlusWidgetLightThemeStyle.SeparatorEnd}
      }
      ${LogoPlusContainer} {
        margin-block-end: 20px;
        padding-block-end: 12px;
        border-block-end: 1px solid rgba(0, 0, 0, 1);
      }
      ${Title} {
        display: none;
      }
      ${StyledPlusWidgetNewsAgenda} {
        margin: 0;
      }
    `}
`;
